import { lazy } from "react";
import Info004 from "../pages/sys/sysApi/info004/Info004";
import Info004Write from "../pages/sys/sysApi/info004/Info004Write";
import Info004WriteAsk from "../pages/sys/sysApi/info004/Info004WriteAsk";
import Info004View from "../pages/sys/sysApi/info004/Info004View";

const Info001 = lazy(() => import("app/pages/info/info001/Info001"));
const Info001Write = lazy(() => import("app/pages/info/info001/Info001Write"));
const Info001View = lazy(() => import("app/pages/info/info001/Info001View"));
const Info002 = lazy(() => import("app/pages/info/info002/Info002"));
const Info002Write = lazy(() => import("app/pages/info/info002/Info002Write"));
const Info003 = lazy(() => import("app/pages/info/info003/Info003"));
const Info003Write = lazy(() => import("app/pages/info/info003/Info003Write"));
const Info003WriteAsk = lazy(() => import("app/pages/info/info003/Info003WriteAsk"));
const Info003View = lazy(() => import("app/pages/info/info003/Info003View"));
const ApiListBase = lazy(() => import("app/pages/sys/sysApi/apiList/ApiListBase"));
const ApiRequestList = lazy(() => import("app/pages/sys/sysApi/apiRequest/ApiRequestList"));
const ApiRequestDetail = lazy(() => import("app/pages/sys/sysApi/apiRequest/ApiRequestDetail"));
const CpInventoryBoard = lazy(() => import("app/pages/cp/inventory/InfoBoard"));

// 정보공개(공통)
export const infoRouter: any = [
  // 공지사항
  { path: "info/info001", element: <Info001 /> },
  { path: "info/info001/form", element: <Info001Write /> },
  { path: "info/info001/detail", element: <Info001View /> },

  // FAQ
  { path: "info/info002", element: <Info002 /> },
  { path: "info/info002/form", element: <Info002Write /> },

  // Q&A
  { path: "info/info003", element: <Info003 /> },
  { path: "info/info003/form", element: <Info003Write /> },
  { path: "info/info003/write-ask", element: <Info003WriteAsk /> },
  { path: "info/info003/detail", element: <Info003View /> },

  // Open API
  { path: 'info/api/list', element: <ApiListBase /> },
  { path: 'info/api/status', element: <ApiRequestList /> },
  { path: 'info/api/status/detail', element: <ApiRequestDetail /> },

  { path: "info/api/info004", element: <Info004 /> },
  { path: "info/api/info004/form", element: <Info004Write /> },
  { path: "info/api/info004/write-ask", element: <Info004WriteAsk /> },
  { path: "info/api/info004/detail", element: <Info004View /> },

  // CP
  { path: 'info/cp/inventory', element: <CpInventoryBoard /> },
]